import { useEffect, useState } from 'react';
import { isNull } from 'lodash';
import { decode as jwtDecode } from 'jsonwebtoken';
import useLocalStorageCache from './useLocalStorageCache';

export default function useToken() {
  const [token, setToken] = useLocalStorageCache('portal:token', null);
  const [tokenData, setTokenData] = useState(null);
  useEffect(() => {
    if (isNull(token)) {
      // setTimeout(() => {
      //   window.location = `/login/?from=${encodeURIComponent(window.location)}`;
      // }, 0);
    } else {
      setTokenData(jwtDecode(token));
    }
  }, [token]);
  return {
    token,
    tokenData,
    setToken,
  };
}
